<template>
<div ref="templateRoot" class="pdf-container" style="background-color: #ffffff !important; color: #000000 !important; isolation: isolate;">        <!-- 1. NAGŁÓWEK GŁÓWNY (Miejsce, daty + Logo) -->
        <div class="d-flex justify-content-between align-items-start mb-3">
            <div class="header-dates">
                <div class="date-row">
                    <span class="date-label">Miejsce wystawienia:</span>
                    <span class="date-dots"></span>
                    <span class="date-value">{{ contract.issuePlace || '---' }}</span>
                </div>
                <div class="date-row">
                    <span class="date-label">Data wystawienia:</span>
                    <span class="date-dots"></span>
                    <span class="date-value">{{ contract.issueDate || '---' }}</span>
                </div>
                <div class="date-row" v-if="contract.agreementEndDate">
                    <span class="date-label">Data końca umowy:</span>
                    <span class="date-dots"></span>
                    <span class="date-value">{{ contract.agreementEndDate }}</span>
                </div>
                <div class="date-row" v-if="contract.dueDate">
                    <span class="date-label">Termin do zapłaty:</span>
                    <span class="date-dots"></span>
                    <span class="date-value">{{ contract.dueDate }}</span>
                </div>
            </div>

            <!-- Logo po prawej (jeśli istnieje w danych sprzedawcy lub w obiekcie umowy) -->
            <div class="header-logo text-end">
                <img v-if="contract.sellerLogoUrl" :src="contract.sellerLogoUrl" alt="Logo" style="max-height: 55px; max-width: 220px; object-fit: contain;" />
                <h3 v-else class="fw-bold text-danger m-0 text-lowercase fs-4">{{ contract.seller?.companyName || '' }}</h3>
            </div>
        </div>

        <!-- 2. TYTUŁ DOKUMENTU -->
        <div class="text-center my-3">
            <h4 class="fw-normal fs-3 m-0">Umowa zadatku nr {{ contract.docNumber || '---' }}</h4>
        </div>

        <!-- 3. BLOK: ZDJĘCIE + SPRZEDAWCA + KUPUJĄCY -->
        <div class="row g-2 mb-3 align-items-stretch">
            <!-- Zdjęcie pojazdu -->
            <div class="col-4">
                <div class="photo-box border h-100 d-flex align-items-center justify-content-center ">
                    <img 
                        v-if="carImageUrl" 
                        :src="carImageUrl" 
                        alt="Zdjęcie pojazdu" 
                        class="img-fluid rounded" 
                        style="max-height: 140px; width: 100%; object-fit: cover;" 
                    />
                    <div v-else class="text-muted small text-center p-3">
                        <i class="bi bi-car-front fs-2 d-block mb-1"></i>
                        [Brak zdjęcia]
                    </div>
                </div>
            </div>

            <!-- Sprzedawca -->
            <div class="col-5">
                <div class="card h-100 border rounded-0">
                    <div class="card-header  py-1 px-2 fw-normal fs-7 border-bottom">Sprzedawca</div>
                    <div class="card-body p-2 fs-7 line-height-sm">
                        <div class="fw-bold">{{ contract.seller?.companyName || formatName(contract.seller) }}</div>
                        <div v-if="contract.seller?.nip">NIP: {{ contract.seller.nip }}<span v-if="contract.seller?.regon">, REGON: {{ contract.seller.regon }}</span></div>
                        <div v-if="contract.seller?.street">{{ contract.seller.street }}</div>
                        <div v-if="contract.seller?.city">{{ contract.seller.postalCode }} {{ contract.seller.city }}</div>
                        <div v-if="contract.seller?.country">Kraj: {{ contract.seller.country }}</div>
                        <div v-if="contract.seller?.email">E-mail: {{ contract.seller.email }}</div>
                        <div v-if="contract.seller?.phone">Tel: {{ contract.seller.phone }}</div>

                        <!-- Konto bankowe -->
                        <div v-if="contract.seller?.bankAccount || contract.bankAccount" class="mt-2 pt-1 border-top">
                            <div class="fw-bold">{{ contract.seller?.bankName || contract.bankName || 'ING' }}</div>
                            <div>Konto {{ contract.carCurrency || 'PLN' }}: {{ contract.seller?.bankAccount || contract.bankAccount }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Kupujący -->
            <div class="col-3">
                <div class="card h-100 border rounded-0">
                    <div class="card-header  py-1 px-2 fw-normal fs-7 border-bottom">Kupujący</div>
                    <div class="card-body p-2 fs-7 line-height-sm">
                        <div class="fw-bold">{{ formatName(contract.buyer) }}</div>
                        <div v-if="contract.buyer?.companyName">{{ contract.buyer.companyName }}</div>
                        <div v-if="contract.buyer?.nip">NIP: {{ contract.buyer.nip }}</div>
                        <div v-if="contract.buyer?.pesel">PESEL: {{ contract.buyer.pesel }}</div>
                        <div v-if="contract.buyer?.phone">Tel: {{ contract.buyer.phone }}</div>
                        <div v-if="contract.buyer?.street">{{ contract.buyer.street }}</div>
                        <div v-if="contract.buyer?.city">{{ contract.buyer.postalCode }} {{ contract.buyer.city }}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 4. TABELA Z SPECYFIKACJĄ POJAZDU -->
        <table class="table table-bordered custom-table mb-2">
            <thead>
                <tr class="">
                    <th style="width: 40px;" class="text-center">LP</th>
                    <th>Nazwa towaru / usługi</th>
                    <th style="width: 140px;" class="text-end">Zadatek</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="text-center">1</td>
                    <td>
                        <div>Kategoria: {{ contract.car?.type || 'Osobowe' }}</div>
                        <div>Marka: {{ contract.car?.make }}, Model: {{ contract.car?.model }}</div>
                        <div>
                            Pojemność silnika: {{ contract.car?.engineCapacity || '---' }}
                            <span v-if="contract.car?.mileage">, Stan licznika: {{ contract.car.mileage }}</span>
                        </div>
                        <div>
                            Typ paliwa: {{ contract.car?.fuelType || '---' }}
                            <span v-if="contract.car?.powerHp">, Moc: {{ contract.car.powerHp }} KM</span>
                            <span v-if="contract.car?.color">, Kolor: {{ contract.car.color }}</span>
                        </div>
                        <div>VIN: {{ contract.car?.vin || '---' }}</div>
                        <div>Numer rejestracyjny pojazdu: {{ contract.car?.registrationPlate || '---' }}</div>
                        <div>
                            Rok produkcji: {{ contract.car?.productionYear || '---' }}
                            <span v-if="contract.car?.firstRegistrationDate">, Data pierwszej rejestracji: {{ contract.car.firstRegistrationDate }}</span>
                        </div>
                    </td>
                    <td class="text-end align-top fw-bold fs-6">
                        {{ formatMoney(contract.depositAmount) }}
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- 5. PODSUMOWANIE KWOTY ZADATKU -->
        <div class="text-end mb-4">
            <div class="fs-4 fw-normal">
                Zadatek: <span class="fw-bold">{{ formatMoney(contract.depositAmount) }} {{ contract.depositCurrency || contract.carCurrency || 'PLN' }}</span>
            </div>
            <div class="fst-italic text-muted small">
                {{ depositAmountInWords }}
            </div>
        </div>

        <!-- 6. POSTANOWIENIA UMOWY -->
        <div class="provisions-section border-top pt-2">
            <ol class="ps-3 mb-0 small line-height-md">
                <li>Strony ustalają wartość zadatkowanego pojazdu na kwotę: <strong>{{ formatMoney(contract.carPrice) }} {{ contract.carCurrency || 'PLN' }}</strong> słownie: {{ carPriceInWords }}</li>
                <li>Kupujący wpłaca zadatek na poczet zakupu pojazdu w wysokości: <strong>{{ formatMoney(contract.depositAmount) }} {{ contract.depositCurrency || 'PLN' }}</strong> słownie: {{ depositAmountInWords }}</li>
                <li>Umowa sprzedaży zabezpieczona niniejszym zadatkiem zostanie zawarta do dnia <strong>{{ contract.agreementEndDate || contract.dueDate || '---' }}</strong></li>
                <li>W przypadku niedotrzymania terminu lub wycofania się kupującego z umowy zadatek przechodzi na rzecz sprzedającego (komisanta) na podstawie Art. 394 KPC</li>
                <li>W sprawach nie uregulowanych niniejszą umową mają zastosowanie przepisy Kodeksu Cywilnego</li>
            </ol>
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
    contract: { type: Object, required: true }
})

const templateRoot = ref(null)

defineExpose({
    element: templateRoot
})

// Wyciąganie adresu URL zdjęcia auta z dowolnej zmiennej API
const carImageUrl = computed(() => {
    return props.contract.carImage || 
           props.contract.car?.photoUrl || 
           props.contract.car?.imageUrl || 
           props.contract.car?.image || 
           props.contract.carImageBase64 || 
           null
})

const formatName = (party) => {
    if (!party) return ''
    if (party.companyName) return party.companyName
    return `${party.firstName || ''} ${party.lastName || ''}`.trim()
}

const formatMoney = (val) => {
    if (!val && val !== 0) return '0.00'
    return Number(val).toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

// Prosta zamiana liczby na słowa (przykładowy wariant dla PLN)
const amountToWords = (amount) => {
    const num = Number(amount) || 0
    if (num === 1000) return 'jeden tysiąc PLN zero gr'
    if (num === 26300) return 'dwadzieścia sześć tysięcy trzyście PLN zero gr'
    // Możesz tu podpiąć swoją pełną funkcję kwotaSlownie()
    return `${num.toFixed(2)} PLN`
}

const depositAmountInWords = computed(() => {
    return props.contract.depositAmountWords || amountToWords(props.contract.depositAmount)
})

const carPriceInWords = computed(() => {
    return props.contract.carPriceWords || amountToWords(props.contract.carPrice)
})
</script>

<style scoped>
.pdf-container {
    width: 210mm;
    padding: 10mm 15mm;
    font-family: Arial, sans-serif;
    font-size: 11px;
    background: #ffffff;
    color: #000000;
    line-height: 1.3;
}

/* Wyrównanie dat kropkami */
.header-dates {
    width: 260px;
}
.date-row {
    display: flex;
    align-items: baseline;
    font-size: 11px;
    margin-bottom: 2px;
}
.date-label {
    white-space: nowrap;
}
.date-dots {
    flex-grow: 1;
    border-bottom: 1px dotted #888888;
    margin: 0 4px;
}
.date-value {
    white-space: nowrap;
    font-weight: 500;
}

/* Kolory nagłówków */
. {
    background-color: #e2e2e2 !important;
}

.fs-7 {
    font-size: 10px;
}

.line-height-sm {
    line-height: 1.25;
}

.line-height-md {
    line-height: 1.4;
}

/* Tabela specyfikacji */
.custom-table {
    font-size: 10.5px;
    border-color: #cccccc;
    background-color:white;
    color:black;
}

.custom-table th {
    font-weight: normal;
    padding: 4px 8px;   background-color:white;
    color:black;
}

.custom-table td {
    padding: 6px 8px;   background-color:white;
    color:black;
}

.provisions-section {
    font-size: 10px;
}
</style>
<style scoped>
/* Resetujemy dziedziczenie dla całego wnętrza PDF, wymuszając tryb jasny */
.pdf-container,
.pdf-container * {
    color: #000000 !important;
    box-sizing: border-box;
}

.pdf-container {
    width: 210mm;
    padding: 10mm 15mm;
    font-family: Arial, sans-serif;
    font-size: 11px;
    background: #ffffff !important;
    color: #000000 !important;
    line-height: 1.3;
}

/* Przywracamy jasne tła dla elementów, które tego wymagają */
.pdf-container .bg-gray {
    background-color: #e2e2e2 !important;
    color: #000000 !important;
}

.pdf-container .card {
    background-color: #ffffff !important;
    border-color: #cccccc !important;
}

.pdf-container .photo-box {
    background-color: #f8f9fa !important;
}
</style>